import { UserDjSoftwareEnum } from '@cratehackers/api-client';
import { IonButton, IonIcon, IonText } from '@ionic/react';
import { apps, arrowForward } from 'ionicons/icons';
import { useState } from 'react';
import djSoftwareService from '../../../services/DJSoftware.service';

import { useIcons } from '../../../hooks/useIcons';
import '../Wizard.scss';
import { getVersionedProductName } from '../../../utils/productName';

interface Props {
  onNext: (selected: UserDjSoftwareEnum[]) => void;
  onSkip?: () => void;
}

export default function SelectDJSoftwareStep({ onNext, onSkip }: Props) {
  const [selected, setSelected] = useState<UserDjSoftwareEnum[]>([]);
  const { icons } = useIcons();

  // First row: Commonly detected software
  const primaryOptions = [
    { id: 'serato', name: 'Serato', icon: icons.seratoDJPro },
    { id: 'virtualdj', name: 'VirtualDJ', icon: icons.virtualDJ },
  ];

  // Second row: Other software options
  const secondaryOptions = [
    { id: 'rekordbox', name: 'Rekordbox', icon: icons.rekordbox },
    { id: 'djayPRO', name: 'djayPRO', icon: icons.djayPro },
    { id: 'other', name: 'Other', icon: apps },
  ];

  const toggle = (id: UserDjSoftwareEnum) =>
    setSelected((s) =>
      s.includes(id) ? s.filter((x) => x !== id) : [...s, id],
    );

  const handleContinue = async () => {
    await djSoftwareService.saveSelectedSoftware(selected);
    onNext(selected);
  };

  const renderOption = (o: any) => {
    const isSelected = selected.includes(o.id as UserDjSoftwareEnum);

    return (
      <div key={o.id} className="option-container">
        <div
          className={`option-card ${isSelected ? 'selected' : ''}`}
          onClick={() => toggle(o.id as any)}
        >
          <div className="option-logo">
            <IonIcon icon={o.icon} className="option-icon" />
          </div>
          <IonText className="option-name">{o.name}</IonText>
        </div>
      </div>
    );
  };

  return (
    <div className="wizard-step">
      <div className="welcome-header">
        <h2>Welcome to {getVersionedProductName()}</h2>
        <p>First, tell us what DJ software you use.</p>
      </div>

      {/* First row: Primary detected software */}
      <div className="option-grid primary-row">
        {primaryOptions.map(renderOption)}
      </div>

      {/* Second row: Other software options */}
      <div className="option-grid secondary-row">
        {secondaryOptions.map(renderOption)}
      </div>

      <IonButton
        expand="block"
        className="next-button"
        onClick={handleContinue}
        disabled={selected.length === 0}
      >
        Continue <IonIcon slot="end" icon={arrowForward} />
      </IonButton>

      {onSkip && (
        <div className="bottom-skip">
          <IonButton
            expand="block"
            fill="clear"
            color="medium"
            onClick={onSkip}
          >
            SKIP FOR NOW - GO TO THE CRATE BUILDER
          </IonButton>
        </div>
      )}
    </div>
  );
}
